import type { ManufacturerProfile, PriceToleranceRule } from "../domain/types";
import { MANUFACTURERS } from "./generatorConfig";

export const generateManufacturers = (): ManufacturerProfile[] => MANUFACTURERS.map((manufacturer) => ({ ...manufacturer }));

export const generatePriceToleranceRules = (manufacturers: ManufacturerProfile[]): PriceToleranceRule[] =>
    manufacturers.map((manufacturer) => ({
        manufacturerId: manufacturer.id,
        manufacturerName: manufacturer.name,
        autoApproveThresholdPct: manufacturer.autoApproveThresholdPct,
        reviewThresholdPct: manufacturer.reviewThresholdPct,
        actionOnBreach: manufacturer.breachAction,
        notes:
            manufacturer.id === "MFR-999"
                ? "Safe default for new or unmapped manufacturers"
                : manufacturer.contractPricing
                  ? "Contract pricing in place"
                  : manufacturer.volatilityIndex > 0.6
                    ? "High-volatility allocation market"
                    : "Standard business-owned threshold",
        owner: manufacturer.contractPricing ? "Procurement" : "Product operations",
        effectiveDate: "2026-05-01",
    }));

